"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fireflyConstants = {
    BYTE_HEX: 0xff,
    BYTE_MAX: 256,
    DEC_VISITOR_ID: 1,
    INTEGER_MAX: 9000000000000000,
    PARTITION_MAX_RANDOM: 9007199254740960,
    PARTITION_MIN_RANDOM: 11184840,
    RADIX_HEX: 16,
    SO_PORTRAIT: 'portrait',
    SO_LANDSCAPE: 'landscape',
    SO_SQUARE: 'square'
};
exports.default = fireflyConstants;
